import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import Typography from '../components/Typography';

function ProductSmokingHero() {
  const { t } = useTranslation();
  return (
    <Container
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        my: 9,
      }}
    >
      <Button
        sx={{
          border: '4px solid currentColor',
          borderRadius: 0,
          height: 'auto',
          py: 2,
          px: 5,
        }}
        component="a"
        href="https://vluxury.kalikratia.com/"
        target="_blank"
        rel="perfochory v luxury suite"
      >
        <Typography
          variant="h4"
          component="span"
          sx={{ alignItems: 'center', justifyContent: 'center' }}
        >
          {t('smoking.text1')}
        </Typography>
      </Button>

      <Typography
        variant="h5"
        component="a"
        target="_blank"
        href="https://vluxury.kalikratia.com/"
        sx={{
          my: 4,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {t('smoking.text2')}
      </Typography>

      <Box
        component="img"
        src="/icons/productBuoy.svg"
        alt="perfochory v luxury suite"
        width={60}
        height={60}
        loading="lazy"
        decoding="async"
        sx={{ width: 60 }}
      />
    </Container>
  );
}

export default ProductSmokingHero;
